import { validateConditionaly } from '@sravni/cosago-react-library/lib/validationSchemes';
import type { AnySchema } from 'yup';
import { mixed } from 'yup';

import { isSatisfyOption } from 'shared/lib';

import type { TCreditFormCommonFields } from 'entities/creditForm';

export const validateAutoFieldIfAutoPurpose = <T>(fieldSchema: AnySchema) =>
  validateConditionaly<T>(
    (purpose: TCreditFormCommonFields['purpose']) => isSatisfyOption(['NewCar', 'UsedCar'], purpose?.value),
    () => fieldSchema,
    () => mixed().nullable(),
  )('purpose');
